// TODO ERIK ta bort denna fil all användning är rensad.

export const USER_REGISTER = '/user';
export const USER_REGISTER_CONFIRM = `/user/confirm`;
export const USER_PASSWORD = '/user/password';
